import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("navAbout")}
              </h1>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                An independent resource dedicated to helping shoppers navigate the AllChinaBuy spreadsheet and make informed purchasing decisions.
              </p>
            </div>

            <div className="space-y-8">
              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Our Mission</h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  AllChinaBuy Spreadsheet is an independent informational website created to help international shoppers discover products, compare sellers, and shop smarter through the AllChinaBuy platform. We are not affiliated with AllChinaBuy and do not represent the company in any way.
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  Our goal is to provide helpful, unbiased content that improves the shopping experience for users of Chinese online marketplaces. We believe informed buyers make better decisions.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">{t("editorialTitle")}</h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  {t("editorialDesc")}
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  All content on this website is for educational and informational purposes only. We do not guarantee the accuracy of third-party information, including seller ratings, product descriptions, shipping costs, or coupon codes. Users should verify all information independently before making purchasing decisions.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">What We Cover</h2>
                <div className="grid sm:grid-cols-2 gap-4">
                  {[
                    "Spreadsheet guides and tutorials",
                    "Product category overviews",
                    "Shipping and logistics information",
                    "Safety and security best practices",
                    "Platform comparisons and reviews",
                    "Coupon and discount code references",
                    "Quality control (QC) guidance",
                    "Warehouse and consolidation tips",
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <span className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                        <i className="ri-check-line text-accent-600 text-xs" />
                      </span>
                      <span className="text-sm text-foreground-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Content Freshness</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  We regularly update our content to reflect changes in the AllChinaBuy platform, shipping policies, and marketplace conditions. Each article includes a last updated date. Priority pages, including the spreadsheet guide, review, shipping cost guide, and safety information, are reviewed and updated most frequently.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-primary-500/10 border border-primary-200/50 text-center">
                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">Explore AllChinaBuy Spreadsheet</h3>
                <p className="text-foreground-600 mb-6 text-sm">Start your shopping journey with the latest resources and guides.</p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-block px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors"
                >
                  {t("heroCtaPrimary")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}